import { render, staticRenderFns } from "./customerPriceListImportTemplateDialog.vue?vue&type=template&id=5311a3dc&"
import script from "./customerPriceListImportTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./customerPriceListImportTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports